import { ColorPalette } from '../types';

export const colorToTailwindTheme = (color: ColorPalette, prefix?: string) => {
  if (color === 'black' || color === 'current' || color === 'transparent' || color === 'white') {
    return prefix ? `${prefix}-${color}` : color;
  }

  const colorSuffix = color.replace('.', '-');
  return prefix ? `${prefix}-${colorSuffix}` : colorSuffix;
};
